/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function (Drupal, $,once) {
  Drupal.behaviors.mainMenu = {
    attach: function (context) {
      "use strict";
      $(once("main-menu-processed","#main-nav"))
        .each(function () {

          function getInnerHeight() {
            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty("--vh", `${vh}px`);
          }

          getInnerHeight();

          $(window).resize(function () {
            getInnerHeight();
          });

          // mobile menu
          var mobileMenu = $(".header-mobile");

          function setMobileHeaderTop() {
            var logo = document.querySelector('.site-branding');
            var mobileHeader = document.querySelector('.header-wrapper .header-mobile');

            const logoOffsetTop = logo.offsetTop  + logo.getBoundingClientRect().height;
            mobileHeader.style.top = logoOffsetTop + 15 + 'px'
            mobileHeader.style.height = (window.innerHeight - logoOffsetTop) + 'px'
            mobileHeader.style.maxHeight = `calc(var(--vh,1vh)*100 - ${logoOffsetTop}px)`
           }

          // mobile menu
          var isMenuOpen = false;

          $(once("mainMenu",".hamburger-menu__wrapper"))
            .click(function () {
              setMobileHeaderTop()
              $(this).toggleClass("active");
              $(".header-mobile").stop().slideToggle(400);

              //disable body scroll when the menu is open
              if (!isMenuOpen) {
                document.body.style.position = 'fixed';
                document.body.style.top = `-${window.scrollY}px`;
                isMenuOpen = true;
              } else {
                var scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
                isMenuOpen = false;
              }
            });

          var mobileMenu = $(".header-mobile");

          if (!(mobileMenu.children().length > 2)) {

            function addMobileMenu() {
              setTimeout(function () {
                if (!$("#main-nav").children().length) {
                  addMobileMenu();
                } else {
                  // social sharing
                  $("#block-socialheaderblock .follow-us")
                  .clone()
                  .addClass("mobile")
                  .prependTo(mobileMenu)

                  $("nav[role='navigation'] .menu.level-0")
                  .clone()
                  .addClass("secondary-menu-mobile")
                  .prependTo(mobileMenu)

                  $(".header #main-nav")
                    .clone()
                    .removeAttr("id")
                    .addClass("mobile-nav")
                    .prependTo(mobileMenu);

                  //mobile mega-menu
                  $(".mobile-nav .expand-sub").click(function () {
                    var $this = $(this);
                    $this
                      .parent()
                      .siblings()
                      .find(".expand-sub--open")
                      .removeClass("expand-sub--open")
                      .siblings("a")
                      .removeClass("is-open")
                      .siblings(".main-menu-block__column-dropdown")
                      .stop()
                      .slideUp(300);
                    $this
                      .toggleClass("expand-sub--open")
                      .siblings("a")
                      .toggleClass("is-open");
                    $this
                      .siblings(".main-menu-block__column-dropdown")
                      .stop()
                      .slideToggle(300);
                  });
                }
              }, 100);
            }
            addMobileMenu();

            window.addEventListener('resize', function() {
              if (window.innerWidth > 1279) {
                mobileMenu.hide();
                $(".hamburger-menu__wrapper").removeClass('active');
                document.body.style.position = '';
                document.body.style.top = '';
                isMenuOpen = false;
              }
              setMobileHeaderTop();
            })
          }

          // 
          const dropdownItems = document.querySelectorAll('.main-menu-block__column.has-children');

          if (dropdownItems.length > 0) {
            
            dropdownItems.forEach(item => {
              const linkButton = item.querySelector('.menu-main-link-level-1');
              const dropdown = item.querySelector('.main-menu-block__column-dropdown');

              if (linkButton && dropdown) {
                linkButton.addEventListener('click', (e) => {
                  if (document.documentElement.clientWidth < 1280) {
                    e.preventDefault();
                    e.stopPropagation();
                    item.classList.toggle('dropdown-open')
                  }
                })

                document.addEventListener('click', (e) => {
                  if (!item.contains(e.target)) {
                    item.classList.remove('dropdown-open');
                  }
                })
              }
            })
          }
        }); // once

      if ($(".search-results").length) {
        $(".status--error").remove();
      }
    },
  };
})(Drupal, jQuery,once);
